module.exports = __webpack_public_path__ + "img/macbook-lms-with-shape.4ef8383d.png";